// utils/markdown.js
import MarkdownIt from 'markdown-it'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css' // 明主题，或用 github-dark 暗主题

const md = new MarkdownIt({
    html: true,         // 允许 HTML 标签
    linkify: true,      // 自动转链接
    typographer: true,  // 更好排版
    highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
            try {
                return `<pre class="hljs"><code>${hljs.highlight(str, { language: lang, ignoreIllegals: true }).value}</code></pre>`
                // eslint-disable-next-line no-empty
            } catch (__) {}
        }
        return `<pre class="hljs"><code>${md.utils.escapeHtml(str)}</code></pre>`
    }
})

// 可选插件（提升体验）
import taskLists from 'markdown-it-task-lists'
import { full as emoji } from 'markdown-it-emoji'
md.use(taskLists, { label: true })
md.use(emoji)

export function renderMarkdown(text) {
    if (!text) return ''
    return md.render(text)
}